import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Icon from 'components/Icon/Icon';

export default class Dropdown extends Component {
  static propTypes = {
    activeStyle: PropTypes.object,
    activeClassname: PropTypes.any,
    inputClassname: PropTypes.any,
    dropdownStyle: PropTypes.object,
    highlightIndex: PropTypes.number,
    id: PropTypes.string,
    itemDisplay: PropTypes.func,
    items: PropTypes.array,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    onClear: PropTypes.func,
    onFocus: PropTypes.func,
    onKeyDown: PropTypes.func,
    onSelect: PropTypes.func,
    onUpdateHighlightIndex: PropTypes.func,
    placeholder: PropTypes.string,
    showDropdown: PropTypes.bool,
    style: PropTypes.object,
    value: PropTypes.string,
    scrollable: PropTypes.bool,
    resultMaxHeight: PropTypes.string,
  };

  render() {
    const {
      activeStyle,
      activeClassname,
      inputClassname,
      dropdownStyle,
      highlightIndex,
      id,
      items,
      placeholder,
      showDropdown,
      style,
      value,
    } = this.props;

    return (
      <div style={{ position: 'relative' }}>
        <input
          id={id ? id : null}
          onBlur={(event) =>
            this.props.onBlur ? this.props.onBlur(event) : null
          }
          onChange={(event) =>
            this.props.onChange ? this.props.onChange(event) : null
          }
          onFocus={(event) =>
            this.props.onFocus ? this.props.onFocus(event) : null
          }
          onKeyDown={(event) =>
            this.props.onKeyDown ? this.props.onKeyDown(event) : null
          }
          className={inputClassname || ''}
          placeholder={placeholder}
          style={{
            boxSizing: 'border-box',
            width: '100%',
            display: 'block',
            border: '1px solid #eee',
            borderRadius: '4px',
            padding: '5px 10px',
            fontFamily: 'Lato',
            paddingRight: '30px',
            ...style,
          }}
          type="text"
          value={value}
        />
        <div
          style={{
            position: 'absolute',
            right: '10px',
            top: '5px',
            display: 'block',
            zIndex: 50,
            transition: 'opacity 0.3s',
            opacity: typeof value !== 'undefined' && value.length > 0 ? 1 : 0,
          }}
        >
          <Icon
            color="#aaa"
            icon="&#xe60d;"
            color="#363c6e"
            style={{ verticalAlign: 'sub' }}
            onClick={() => this.props.onClear()}
          />
        </div>
        <div
          style={{
            position: 'absolute',
            width: '100%',
            zIndex: 100,
            boxShadow: '0 3px 2px #ccc',
            boxSizing: 'border-box',
            backgroundColor: '#fff',
            border: showDropdown && items.length > 0 ? '1px solid #eee' : '0',
            borderRadius: '4px',
            maxHeight: showDropdown
              ? items.length > 0
                ? this.props.resultMaxHeight || '1000px'
                : '30px'
              : '0',
            overflowX: 'hidden',
            overflowY: this.props.scrollable ? 'scroll' : 'hidden',
            transition:
              'max-height 0.3s cubic-bezier(0, 1, 0.5, 1)' +
              (showDropdown && items.length > 0
                ? ''
                : ', border 0s ease 0.25s'),
            ...dropdownStyle,
          }}
        >
          {items.length === 0 &&
            value !== '' &&
            this.props.itemDisplay({ name: 'No Results Found' })}
          {items &&
            items.map((item, index) => (
              <div
                onMouseDown={() =>
                  this.props.onSelect ? this.props.onSelect(item) : null
                }
                style={Object.assign(
                  { cursor: 'pointer' },
                  highlightIndex === index ? activeStyle : {}
                )}
                className={highlightIndex === index ? activeClassname : ''}
                key={index}
                onMouseOver={() =>
                  this.props.onUpdateHighlightIndex
                    ? this.props.onUpdateHighlightIndex(index)
                    : null
                }
              >
                {this.props.itemDisplay(item, highlightIndex === index, index)}
              </div>
            ))}
        </div>
      </div>
    );
  }
}
